import script from "./MutatedSettingsProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./MutatedSettingsProfile.vue?vue&type=script&lang=ts&setup=true"

import "./MutatedSettingsProfile.vue?vue&type=style&index=0&id=331a8868&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331a8868"]])

export default __exports__